import { render, staticRenderFns } from "./ed-blank-whiteboard.vue?vue&type=template&id=76554ef9&scoped=true&"
import script from "./ed-blank-whiteboard.ts?vue&type=script&lang=ts&"
export * from "./ed-blank-whiteboard.ts?vue&type=script&lang=ts&"
import style0 from "./ed-blank-whiteboard.scss?vue&type=style&index=0&id=76554ef9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76554ef9",
  null
  
)

export default component.exports